interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({
  current,
  totalPages,
  onChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav
      aria-label="分页导航"
      className="mt-8 flex flex-wrap items-center justify-center gap-2"
    >
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? "page" : undefined}
          className={`h-9 w-9 rounded-md text-sm font-medium transition-colors ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, current + 1))}
        disabled={current === totalPages}
        className="flex items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </nav>
  );
}